/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * No image server for this datasource
 * @export
 * @interface GetCorporationsCorporationIdIconsNotFound
 */
export interface GetCorporationsCorporationIdIconsNotFound {
    /**
     * error message
     * @type {string}
     * @memberof GetCorporationsCorporationIdIconsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdIconsNotFound interface.
 */
export function instanceOfGetCorporationsCorporationIdIconsNotFound(value: object): value is GetCorporationsCorporationIdIconsNotFound {
    return true;
}

export function GetCorporationsCorporationIdIconsNotFoundFromJSON(json: any): GetCorporationsCorporationIdIconsNotFound {
    return GetCorporationsCorporationIdIconsNotFoundFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdIconsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdIconsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCorporationsCorporationIdIconsNotFoundToJSON(json: any): GetCorporationsCorporationIdIconsNotFound {
    return GetCorporationsCorporationIdIconsNotFoundToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdIconsNotFoundToJSONTyped(value?: GetCorporationsCorporationIdIconsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

